/* ============================================================
   Pholoh PDP — relocate the Bundler app section into the info column.

   On desktop the gallery is position:sticky (left) and .product-single__meta
   scrolls (right). The Bundler was added in the theme editor as its own
   full-width section below the fold; move it INTO the meta column so it reads
   as part of the product info — the shopper scrolls past it while the image
   stays pinned on the left. On mobile it stays in its authored position.

   Done in JS (not by editing product.json) because that template is
   theme-editor-owned and reverts CLI pushes. This asset loads fresh.
   ============================================================ */
(function () {
  'use strict';
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;

  var SECTION_ID = 'shopify-section-1783181251b95ebfa2';   // the Bundler "apps" section
  var mq = window.matchMedia('(min-width: 769px)');
  var bundler = null;
  var placeholder = null;

  // Find the Bundler section: by its authored id, else any .shopify-section that
  // carries bundler markup (survives a remove + re-add that changes the id).
  function findBundler() {
    var el = document.getElementById(SECTION_ID);
    if (el) return el;
    var secs = document.querySelectorAll('.shopify-section');
    for (var i = 0; i < secs.length; i++) {
      if (secs[i].querySelector('[class*="bundler" i], [id*="bundler" i], [data-bundler]')) return secs[i];
    }
    return null;
  }

  function place() {
    if (!bundler) bundler = findBundler();
    if (!bundler) return;
    var meta = document.querySelector('.product-single__meta');
    if (!meta) return;

    bundler.classList.add('pholoh-pdp-bundler');

    // Remember the authored spot once so mobile can go back to it.
    if (!placeholder) {
      placeholder = document.createComment('pholoh-bundler-home');
      if (bundler.parentNode) bundler.parentNode.insertBefore(placeholder, bundler);
    }

    if (mq.matches) {
      // Desktop: last in the scrolling info column, below the description + tabs.
      if (bundler.parentNode !== meta) meta.appendChild(bundler);
    } else if (placeholder.parentNode && bundler.previousSibling !== placeholder) {
      // Mobile: restore to the authored below-the-fold position.
      placeholder.parentNode.insertBefore(bundler, placeholder.nextSibling);
    }

    // Products with no bundle configured render an EMPTY target. Collapse the
    // separator + padding in that case so there's no stray rule / whitespace.
    // (Collapse, not display:none — an empty target must stay in flow so an app
    // that injects on visibility can still fill it, after which this re-shows.)
    // Signal = the app target's own rendered height, NOT "has a media element":
    // that mis-fired on the app's transient loading <svg> spinner. Height is 0
    // for an empty widget and non-zero once a real bundle renders.
    var target = bundler.querySelector('#bundler-target-element')
      || bundler.querySelector('.shopify-app-block') || bundler;
    // Filled only when the app injected real child nodes AND they take up space.
    // A no-bundle product leaves an empty <div id="bundler-target-element"></div>
    // (zero children) -> stays collapsed; the child-count guard also stops a
    // stray margin/height from reading as content.
    var hasContent = target.children.length > 0
      && ((target.offsetHeight || 0) > 4 || !!(target.innerText && target.innerText.trim()));
    bundler.classList.toggle('pholoh-pdp-bundler--empty', !hasContent);
  }

  if (document.readyState !== 'loading') place();
  else document.addEventListener('DOMContentLoaded', place);
  window.addEventListener('load', place);

  // The app widget can inject late; re-place on DOM changes, then stop.
  // (The parentNode guard makes each call idempotent — no move loop.)
  var mo = new MutationObserver(place);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 12000);
  // Belt-and-suspenders re-checks so a late render (or a spinner that clears
  // after the last mutation) still settles the empty/filled state correctly.
  [1500, 4000, 9000].forEach(function (t) { setTimeout(place, t); });

  if (mq.addEventListener) mq.addEventListener('change', place);
  else if (mq.addListener) mq.addListener(place);
})();
